import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  FormWrapperContainer,
  ChartWrapperContainer,
  ResultsContainer,
  LoaderContainer,
} from './containers';
import './App.css';

class App extends Component {
  componentDidMount() {
  }
  
  render() {
    return this.props.loading
    ? (
      <div className="App loading Body-1">
        <LoaderContainer />
      </div>
    )
    : (
      <div className="App display-container Body-1">
        <FormWrapperContainer />
        <ResultsContainer />
        <ChartWrapperContainer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.tickers.loading,
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js